export default __webpack_public_path__ + "static/media/property-safety.f8bd7f9b.svg";